import { render } from "./FailedTransactionsTable.vue?vue&type=template&id=f8a51fcc&scoped=true"
import script from "./FailedTransactionsTable.vue?vue&type=script&lang=js"
export * from "./FailedTransactionsTable.vue?vue&type=script&lang=js"

import "./FailedTransactionsTable.vue?vue&type=style&index=0&id=f8a51fcc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a51fcc"]])

export default __exports__